/* rescens circle — interactions */
(function() {
  'use strict';

  // Reveal on scroll (progressive enhancement)
  function initReveal() {
    var els = document.querySelectorAll('.rcle .reveal');
    if (!els.length || !('IntersectionObserver' in window)) return;
    // Add pre-anim class so elements start hidden, then animate
    els.forEach(function(el) { el.classList.add('rcle-pre-anim'); });
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function() { entry.target.classList.add('in'); }, i * 60);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function(el) { obs.observe(el); });
  }

  // Sticky Apply Bar
  function initStickyBar() {
    var bar = document.querySelector('.rcle-sticky-bar');
    var hero = document.querySelector('.rcle-hero');
    var form = document.querySelector('#rcle-apply-form');
    if (!bar || !hero) return;

    function check() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var inFormView = false;
      if (form) {
        var fr = form.getBoundingClientRect();
        inFormView = fr.top < window.innerHeight && fr.bottom > 0;
      }
      if (heroBottom < 0 && !inFormView) bar.classList.add('show');
      else bar.classList.remove('show');
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  // Earnings Calculator
  function initCalculator() {
    var box = document.querySelector('[data-rcle-calc]');
    if (!box) return;

    var salesSlider = box.querySelector('[data-rcle-sales-slider]');
    var tierSlider = box.querySelector('[data-rcle-tier-slider]');
    var salesValue = box.querySelector('[data-rcle-sales-value]');
    var tierValue = box.querySelector('[data-rcle-tier-value]');
    var resultValue = box.querySelector('[data-rcle-result-value]');

    if (!salesSlider || !tierSlider) return;

    var saleValue = parseFloat(box.dataset.rcleSaleValue) || 49;
    var tiers = [];
    try {
      tiers = JSON.parse(box.dataset.rcleTiers || '[]');
    } catch (e) {
      tiers = [
        { name: 'Initiate', commission: 0.10 },
        { name: 'Insider', commission: 0.15 },
        { name: 'Atelier', commission: 0.20 },
        { name: 'Muse', commission: 0.25 }
      ];
    }

    function update() {
      var sales = parseInt(salesSlider.value, 10);
      var tierIndex = Math.min(parseInt(tierSlider.value, 10) - 1, tiers.length - 1);
      var tier = tiers[tierIndex] || tiers[0];
      var earnings = Math.round(sales * saleValue * tier.commission);

      if (salesValue) salesValue.textContent = sales;
      if (tierValue) tierValue.textContent = tier.name;
      if (resultValue) resultValue.textContent = earnings;
    }

    salesSlider.addEventListener('input', update);
    tierSlider.addEventListener('input', update);
    update();
  }

  // Init
  function init() {
    initReveal();
    initStickyBar();
    initCalculator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

